import Pusher from 'pusher-js';

const pusher = new Pusher('2c6861ac10c9749d9d70', {
  cluster: 'ap1',
  forceTLS: true
});

export default pusher;
